import React, { useState } from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
  const kulamList = [
    "Beerahavaru",
    "Bodhuvaru",
    "Bomma jallivaru",
    "Boothivaru",
    "Dhasarivaru",
    "Dheiyaluvaru",
    "Dhogaluvaru",
    "Dhommaluvaru",
    "Dhoothaluvaruu",
    "Eeraluvaru",
    "Engiti aaguluvaru",
    "Entaluvaru",
    "Entavaru",
    "Eramavaru",
    "Etthulu Thantavaru",
    "Janavaru",
    "Jallivaru",
    "Jitthaluvaru",
    "Kachchavaru",
    "Kannadivaru",
    "Karavaru",
    "Kejjaluvaru",
    "Kodavaru",
    "Kommuvaru",
    "Kommuluvaru",
    "Kobaluvaru",
    "Koolivaru",
    "Kothaluvaru",
    "Kotangivaru",
    "Kuntamukkavaru",
    "Kuntavaru",
    "Kurukunjaluvaru",
    "Machchaluvaru",
    "Maithulavaru",
    "Mangavaru",
    "Mamidikuntaluvaru",
    "Mudikiluvaru",
    "Nallamullavaru",
    "Nelliyamvaru",
    "Other",
    "Pachchiluvaru",
    "Pallavaru",
    "Pandhivaru",
    "Pantivaru",
    "Paravaru",
    "Parvaivaru",
    "Patamasalavaru",
    "Payidikutthaluvaru",
    "Peguluvaru",
    "Pittavaru",
    "Pannavaru",
    "Puliputthaluvaru",
    "Rama jallivaru",
    "Santhavaru",
    "Sembootthuluvaru",
    "Settiselvaru",
    "Soothaluvaru",
    "Sullivaru",
    "Sutravaru",
    "Vejivaru"
  ];



const AddKulam = ({ data, handleChange, handleSubmit, styles }) => (
  <form onSubmit={handleSubmit}>
    <FormGroup>
      <Label for="fatherKulam" style={styles.label}>
        Father Kulam
      </Label>
      <Input
        type="select"
        name="fatherKulam"
        id="fatherKulam"
        value={data.fatherKulam}
        onChange={handleChange}
        style={styles.input}
        required
      >
        <option value="">Select Father Kulam</option>
        {kulamList.map((kulam, index) => (
          <option key={index} value={kulam}>
            {kulam}
          </option>
        ))}
      </Input>
    </FormGroup>

    <FormGroup>
      <Label for="motherKulam" style={styles.label}>
        Mother Kulam
      </Label>
      <Input
        type="select"
        name="motherKulam"
        id="motherKulam"
        value={data.motherKulam}
        onChange={handleChange}
        style={styles.input}
        required
      >
        <option value="">Select Mother Kulam</option>
        {kulamList.map((kulam, index) => (
          <option key={index} value={kulam}>
            {kulam}
          </option>
        ))}
      </Input>
    </FormGroup>
    <FormGroup>
      <Label for="kulaDeivam" style={styles.label}>
        Kula Deivam
      </Label>
      <Input
        type="text"
        name="kulaDeivam"
        id="kulaDeivam"
        value={data.kulaDeivam}
        onChange={handleChange}
        placeholder="Enter Kula Deivam"
        style={styles.input}
        required
      />
    </FormGroup>

    <FormGroup>
      <Label for="templeLocation" style={styles.label}>
        Temple Location
      </Label>
      <Input
        type="textarea"
        name="templeLocation"
        id="templeLocation"
        value={data.templeLocation}
        onChange={handleChange}
        placeholder="Enter Temple Location"
        style={{ ...styles.input, minHeight: 80 }}
        required
      />
    </FormGroup>

    <Button
      type="submit"
      style={{
        width: "30%",
        borderRadius: 8,
        backgroundColor: "#000",
        color: "#fff",
        fontWeight: "bold",
        padding: "10px 0",
      }}
    >
      Save & Continue
    </Button>
  </form>
);

const AddKulamPage = () => {
  const history = useHistory();
  let { id } = useParams();

  const [data, setData] = useState({
    fatherKulam: "",
    motherKulam: "",
    kulaDeivam: "",
    templeLocation: "",
  });

  const styles = {
    label: {
      fontWeight: "800",
      marginBottom: 6,
      color: "#000",
    },
    input: {
      borderRadius: 12,
      border: "1.5px solid #757575",
      padding: 10,
      fontWeight: "bold",
      fontSize: 15,
      color: "#333",
    },
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: id, // Replace this with dynamic userId if needed
      ...data,
    };

    api
      .post("/admin/userProfile/addkulam", payload)
      .then((res) => {
        Swal.fire("Success", "Kulam details saved successfully", "success");
        history.push(`/addfamily/${id}`); // or your next route
      })
      .catch((err) => {
        Swal.fire(
          "Error",
          (err && err.message) || "Something went wrong",
          "error"
        );
      });
  };

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: "50px 20px",
        padding: 20,
        background: "#f9f9f9",
        borderRadius: 20,
        boxShadow: "0 4px 16px rgba(0,0,0,0.04)",
      }}
    >
      <h4 style={{ color: "#1a237e", fontWeight: "900", marginBottom: 20 }}>
        Kulam & Kula Deiva Details
      </h4>

      <AddKulam
        data={data}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        styles={styles}
      />
    </div>
  );
};

export default AddKulamPage;
